import React from 'react';

const ErrorPage = ()=> (
  <h1>404 - PAGE NOT FOUND</h1>
);

export default ErrorPage;
